module.exports = __webpack_public_path__ + "img/AG_logo.ef950c59.png";